export default "images/wx.png";